// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settlement-config-settings select {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  font-size: 12px;
  border-radius: 5px;
  width: 155px;
  padding: 8px 15px;
  opacity: 0.5;
}

.settlement-config-settings .form-control {
  background: #ebebebc9 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
}

.settlement-config-settings form {
  width: 960px;
}

.settlement-config-settings h3 {
  font-size: 18px;
}

.payment-settlement-switch .btn-area {
  display: flex;
  justify-content: space-between;
}

.payment-settlement-switch .btn-area .btn {
  padding-inline: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
  height: unset;
  font-size: 12px;
}

.payment-settlement-switch .edit-switch-btn {
  background-color: rgb(224, 219, 219);
  color: #000;
}

.payment-settlement-switch .edit-switch-btn:hover {
  background-color: rgb(229, 228, 228);
}

.payment-settlement-switch .delete-switch-btn {
  background-color: rgb(225, 44, 44);
  color: #fff;
}

.payment-settlement-switch .delete-switch-btn:hover {
  background-color: rgb(225, 95, 95);
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/payment-gateway/settlement-config/SettlementSwitch.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".settlement-config-settings select {\n  background: #ffffff 0% 0% no-repeat padding-box;\n  border: 1px solid #707070;\n  font-size: 12px;\n  border-radius: 5px;\n  width: 155px;\n  padding: 8px 15px;\n  opacity: 0.5;\n}\n\n.settlement-config-settings .form-control {\n  background: #ebebebc9 0% 0% no-repeat padding-box;\n  border: 1px solid #707070;\n}\n\n.settlement-config-settings form {\n  width: 960px;\n}\n\n.settlement-config-settings h3 {\n  font-size: 18px;\n}\n\n.payment-settlement-switch .btn-area {\n  display: flex;\n  justify-content: space-between;\n}\n\n.payment-settlement-switch .btn-area .btn {\n  padding-inline: 12px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  height: unset;\n  font-size: 12px;\n}\n\n.payment-settlement-switch .edit-switch-btn {\n  background-color: rgb(224, 219, 219);\n  color: #000;\n}\n\n.payment-settlement-switch .edit-switch-btn:hover {\n  background-color: rgb(229, 228, 228);\n}\n\n.payment-settlement-switch .delete-switch-btn {\n  background-color: rgb(225, 44, 44);\n  color: #fff;\n}\n\n.payment-settlement-switch .delete-switch-btn:hover {\n  background-color: rgb(225, 95, 95);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
